import GroupContextBiologicalsListing from "../../components/biologicals/GroupContextBiologicalsListing.vue";
import MultiBiologicalsListing from "../../components/biologicals/MultiBiologicalsListing.vue";

require("../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css");

const routes = [
  {
    path: "/raft/biologicals",
    component: MultiBiologicalsListing,
  },
  {
    path: "/raft/biologicals/:groupNid([0-9]+)",
    component: MultiBiologicalsListing,
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/bio-tracking",
    component: MultiBiologicalsListing,
    props: (route) => ({
      groupNid: route.params.groupNid,
    }),
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/bio/:materialType([a-z0-9_]+)",
    component: GroupContextBiologicalsListing,
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/bio/:materialType([a-z0-9_]+)/:displayId([a-z0-9_]+)",
    component: GroupContextBiologicalsListing,
    props: true,
  },
];

const globalComponents = {};

export {
  routes as bioB4ListingRoutes,
  globalComponents as bioB4ListingGlobalComponents,
};
